import { Route, Routes, useLocation } from "react-router-dom"
import Agenda from "../components/agenda"
import ComiteCientifico from "../components/comitecientifico"
import Conferencistas from "../components/conferencistas"
import Home from "../components/home"
import Hospedajes from "../components/hospedajes"
import Inscripcion from "../components/inscripcion"
import Instrucciones from "../components/instrucciones"
import Mantenimiento from "../components/mantenimiento"
import Mesas from "../components/mesas"
import Pagos from "../components/pagos"
import Patrocinadores from "../components/patrocinadores"
import Registros from "../components/registros"
import Resumenes from "../components/resumenes"

const MainRouter = () => {

    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/inicio' element={<Home />} />
            <Route path='/mesas' element={<Mesas />} />
            <Route path='/agenda' element={<Agenda />} />
            <Route path='/instrucciones' element={<Instrucciones />} />
            <Route path='/inscripcion' element={<Inscripcion />} />
            <Route path='/resumenes' element={<Resumenes />} />
            <Route path='/pagos' element={<Pagos />} />
            <Route path='/comitecientifico' element={<ComiteCientifico />} />
            <Route path='/patrocinadores' element={<Patrocinadores />} />
            <Route path='/conferencistas' element={<Mantenimiento />} />
            <Route path='/hospedajes' element={<Hospedajes />} />
            <Route path='/registros' element={<Registros />} />
            <Route path='/memoria' element={<Redirector />} />
        </Routes>
    )
}

const Redirector = () => {
    window.open('https://drive.google.com/file/d/1XiIT30Xch3HFPSgY4qg0X1Brrbr66zi7/view?usp=drive_link', "Memoria XVI Congreso")
    return null
}

export default MainRouter